export interface ITipoMinuta {
    codigo: TipoMinuta;
    descricao: string;
    ativo?: boolean;
    checked?: boolean;
}

export enum TipoMinuta {
    DESPACHO = 1,
    DECISAO = 2,
    VOTO = 3,
    VOTO_VENCIDO = 4,
    VOTO_FASE_FUTURA = 5,
    ATO_ORDINATORIO = 6,
    VOTO_AGUIA= 7
}
export class Despacho {
    codigo: number = TipoMinuta.DESPACHO;
    descricao: string = 'Despacho';
}

export class AtoOrdinatorio {
    codigo: number = TipoMinuta.ATO_ORDINATORIO;
    descricao: string = 'Ato Ordinatório'
}

export class Decisao {
    codigo: number = TipoMinuta.DECISAO;
    descricao: string = 'Decisao';
}

export class Voto {
    codigo: number = TipoMinuta.VOTO;
    descricao: string = 'Voto';
}

export class VotoVencido {
    codigo: number = TipoMinuta.VOTO_VENCIDO;
    descricao: string = 'Justificativa de Voto vencido';
}

export class VotoFaseFutura {
    codigo: number = TipoMinuta.VOTO_FASE_FUTURA;
    descricao: string = 'Voto de fase futura (AG Provido)';
}

export enum TipoMovimento {
    DECISAO_TERMINATIVA = 1,
    DECISAO_INTERLOCUTORIA = 2,
    DESPACHO = 3
}
export class DECISAO_TERMINATIVA {
    codigo: number = TipoMovimento.DECISAO_TERMINATIVA;
    descricao: string = 'Decisão terminativa';
}

export class DECISAO_INTERLOCUTORIA {
    codigo: number = TipoMovimento.DECISAO_INTERLOCUTORIA;
    descricao: string = 'Decisão interlocutória';
}

export class DESPACHO {
    codigo: number = TipoMovimento.DESPACHO;
    descricao: string = 'Despacho';
}

export const ARRAY_TIPO_MINUTAS = [new Despacho(), new Decisao(), new Voto(), new VotoVencido(), new VotoFaseFutura(), new AtoOrdinatorio()];

// Classes de processo elegíveis para geração de minuta (Voto) com ÁguIA.
export const CLASSES_QUE_PODEM_GERAR_MINUTA_COM_AGUIA = ['RR', 'AIRR', 'Ag-AIRR'];

// Classes de processo elegíveis para exibir o Resumo Águia (inclui RRAg, que não gera minuta com ÁguIA).
export const CLASSES_QUE_PODEM_EXIBIR_RESUMO_AGUIA = ['RR', 'AIRR', 'Ag-AIRR', 'RRAg'];
